import {
  ApolloError,
  ApolloQueryResult,
  NetworkStatus,
  OperationVariables,
  QueryResult,
  useLazyQuery,
  useQuery,
} from '@apollo/client'
import {
  GET_ENROLLMENT,
  GET_ENROLLMENT_IDS_INFO,
} from './queries/getEnrollment'
import { IEnrollment } from '@dtos/Enrollment'
import { IOrdenationInput, IPaginationInput } from '@dtos/Pagination'

export interface IRefetchEnrollment {
  (): Promise<ApolloQueryResult<{ enrollment: IEnrollment }>>
}

export const useEnrollment = (
  id: string,
  ordenation: IOrdenationInput,
  courseId: string,
  pagination: IPaginationInput,
  options: { skip?: boolean } = {},
) => {
  const { data, loading, error, refetch, networkStatus, fetchMore } = useQuery(
    GET_ENROLLMENT,
    {
      variables: { id, ordenation, courseId, pagination },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
      skip: options.skip,
    },
  )

  return { data, loading, error, refetch, networkStatus, fetchMore } as {
    data: IEnrollment | null
    loading: boolean
    error: ApolloError
    refetch: IRefetchEnrollment
    networkStatus: NetworkStatus
    fetchMore: ReturnType<typeof useQuery>['fetchMore']
  }
}

export const useEnrollmentIdsInfo = () => {
  const [getEnrollmentIdsInfo, { data, loading, error }] = useLazyQuery(
    GET_ENROLLMENT_IDS_INFO,
  )

  return { getEnrollmentIdsInfo, data, loading, error } as {
    getEnrollmentIdsInfo: (
      variables: OperationVariables,
    ) => Promise<QueryResult<{ enrollment: IEnrollment }, OperationVariables>>
    data: IEnrollment | null
    loading: boolean
    error: ApolloError
  }
}
